import type { FigmaIconProps } from './types';

interface IconFigmaBellProps extends FigmaIconProps {
  withDot?: boolean;
}

export const IconFigmaBell = ({
  size = 17,
  color = 'currentColor',
  withDot = false
}: IconFigmaBellProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.25 5.66667C4.25 4.5395 4.69777 3.45849 5.4948 2.66146C6.29183 1.86443 7.37283 1.41667 8.5 1.41667C9.62717 1.41667 10.7082 1.86443 11.5052 2.66146C12.3022 3.45849 12.75 4.5395 12.75 5.66667C12.75 10.625 14.875 12.0417 14.875 12.0417H2.125C2.125 12.0417 4.25 10.625 4.25 5.66667Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.29583 14.875C7.4144 15.0906 7.58869 15.2705 7.80051 15.3958C8.01234 15.521 8.25391 15.5871 8.5 15.5871C8.74609 15.5871 8.98766 15.521 9.19949 15.3958C9.41131 15.2705 9.5856 15.0906 9.70417 14.875"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {withDot && (
      <circle
        cx="13.5"
        cy="3"
        r="2.5"
        fill="var(--color-accent-primary)"
        stroke="var(--color-bg-surface)"
      />
    )}
  </svg>
);
